import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { CommandService, ICommand } from "~app/common/services/cqs/command.service";
import { AddLeverantorsorderradCommand } from "../../commands/AddLeverantorsorderradCommand";
import { ILeverantorsorderDetail, ILeverantorsorderDetailRad } from "../../models/leverantorsorder-detail-model";
import { LeverantorsorderradEditComponent } from "../leverantorsorderrad-edit/leverantorsorderrad-edit.component";

@Component({
    selector: "rask-leverantorsorderrad-create",
    templateUrl: "./leverantorsorderrad-create.component.html",
    styleUrls: ["./leverantorsorderrad-create.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LeverantorsorderradEditComponent]
})
export class LeverantorsorderradCreateComponent implements OnInit, OnDestroy {
    @Input() enableCommands: boolean;
    model: ILeverantorsorderDetailRad;
    @Output() modelCreated = new EventEmitter<ILeverantorsorderDetailRad>();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onAdd = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClose = new EventEmitter();
    @Input() order: ILeverantorsorderDetail;
    pushedSubsciption: Subscription;
    @Input() rootForm: UntypedFormGroup;

    private readonly commandService = inject(CommandService);

    constructor() {
        this.initModel();
    }

    close() {
        this.rootForm.removeControl("levorder0");
        this.removeCommand();
        this.onClose.emit();
    }

    getAddCommand(commandStack: ICommand[]) {
        return commandStack.find(t => t.$type === AddLeverantorsorderradCommand.type);
    }

    initModel() {
        this.model = {
            id: 0,
            balans: 0,
            handelssortimentsgrupp: undefined,
            mattslag: undefined,
            kvantitet: undefined,
            periodFrom: new Date().toLocaleDateString("sv-SE"),
            periodTom: undefined,
            egenBefraktning: undefined
        } as any;
    }

    ngOnDestroy() {
        this.pushedSubsciption.unsubscribe();
    }

    ngOnInit(): void {
        this.pushedSubsciption = this.commandService.commandsPushed.subscribe(this.onSave);
        this.modelCreated.emit(this.model);
    }

    onSave = (savedCommands: ICommand[]) => {
        if (this.getAddCommand(savedCommands)) {
            this.onAdd.emit(this.model);
            this.close();
        }
    };

    removeCommand() {
        const command = this.getAddCommand(this.commandService.transactionCommandQueue);
        if (command) {
            const pos = this.commandService.transactionCommandQueue.indexOf(command);
            this.commandService.transactionCommandQueue.splice(pos, 1);
        }
    }
}
